export default "__VITE_ASSET__BrQdJ2gv__"